import { Folders } from './PrimaryMailFolderTreeContainer.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { MailFolderList } from 'owa-mail-folder-view';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getMailRootFolderChildIds } from 'owa-folders';

import { lazyToggleFolderTreeExpansion } from 'owa-mail-folder-store';
import { lazyDeleteFolderInFolderForest } from 'owa-mail-folder-forest-actions';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { ActionSource } from 'owa-mail-store';
import { isFolderUnderDeletedItemsFolder } from 'owa-mail-store';
import {
    getPrimaryMailboxRootFolder,
    getMailboxLoadingState,
    PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID,
    PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID,
    Folder,
    PRIMARY_FOLDERS_TREE_TYPE,
} from 'owa-folders';

export interface PrimaryMailFolderTreeContainerProps {
    showRootNode: boolean;
    className: string;
}

/**
 * Primary mailbox container
 */
export default observer(function PrimaryMailFolderTreeContainer(
    props: PrimaryMailFolderTreeContainerProps
) {
    // Primary mailbox root click handler
    const onRootNodeChevronClicked = () => {
        lazyToggleFolderTreeExpansion.importAndExecute();
    };

    const onDeleteFolder = (folder: Folder, actionSource: ActionSource) => {
        const primaryDeletedItemsFolderId = folderNameToId(PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID);
        const isFolderUnderDeletedItemFolder = isFolderUnderDeletedItemsFolder(
            folder,
            PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID
        );
        lazyDeleteFolderInFolderForest.importAndExecute(
            folder.FolderId.Id,
            actionSource,
            primaryDeletedItemsFolderId,
            isFolderUnderDeletedItemFolder
        );
    };

    const userConfiguration = getUserConfiguration();
    const isExplicitLogon = userConfiguration?.SessionSettings?.IsExplicitLogon;

    return (
        <MailFolderList
            className={props.className}
            key="primarymailboxtree"
            showRootNode={props.showRootNode}
            rootFolder={getPrimaryMailboxRootFolder()}
            isRootExpanded={!userConfiguration.UserOptions.IsMailRootFolderTreeCollapsed}
            rootDisplayName={loc(Folders)}
            childFolderIds={getMailRootFolderChildIds('primary')}
            onRootNodeChevronClickedCallback={onRootNodeChevronClicked}
            treeType={PRIMARY_FOLDERS_TREE_TYPE}
            isFavoritesSupported={!isExplicitLogon} // Favorites not supported for explicit logon scenarios
            onDeleteFolderCallback={onDeleteFolder}
            loadingState={getMailboxLoadingState(PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID)}
            shouldBeDroppable={true}
        />
    );
});
